import axios from '@fs/zion-axios'

const serviceBase = '/service/discovery'

export const getMiniTree = () => {
  return axios.get(`${serviceBase}/allaboutme/getFamily?generations=2&includeLocations=false`)
}

export const updatePersonOnServer = async ({ person }) => {
  const response = await axios.put(`${serviceBase}/common/tree/person`, person)
  return response ? response.data : response
}

export const createPersonAndRelationships = async ({ payloadDetails }) => {
  const response = await axios.post(`${serviceBase}/common/tree/person/relationship`, payloadDetails)
  return response && response.data ? response.data.id : null
}
